import Chart from "chart.js/auto";
import ChartDeferred from "chartjs-plugin-deferred";
import { setCSSCustomProperty } from "../helpers/css";
import { Navigation } from "swiper/modules";
import { CountUp } from "countup.js";
import wait from "../helpers/wait";
import Swiper from "swiper";
import "swiper/css";
import "swiper/css/navigation";

const isPage = (slug) => {
  const bodyDataPage = document.body.getAttribute("data-page");
  return bodyDataPage && bodyDataPage.includes(slug);
};

export const UIController = {
  init() {
    return new Promise((resolve, reject) => {
      try {
        if (isPage("front-page")) {
          this.initBoxSlideGalleryBlockSwipers();
          this.initBoxSlideGalleryMultiBlockSwipers();
          this.initCountUp();
          this.initMeasurementCheckersHome();
        }

        if (isPage("organisation")) {
          this.initCountUp();
          this.initBarChart();
          this.initBarLineChart();
          this.initStackedBarLineChart();
          this.initDoughnutChart();
        }

        if (isPage("championships")) {
          this.initStackedBarChart();
          this.initBoxSlideGalleryBlockSwipers();
          this.initCountUp();
        }

        if (isPage("members")) {
          this.initCountUp();
        }

        if (isPage("network")) {
          this.initBoxSlideGalleryBlockSwipers();
        }

        if (isPage("appendix-2")) {
          this.initGroupedBarChart();
        } else {
          this.initCountUp();
        }

        resolve();
      } catch (error) {
        reject(error);
      }
    });
  },

  initGroupedBarChart() {
    Chart.register(ChartDeferred);
    Chart.defaults.color = "#000C1A"; // Text color
    var ctx = document.getElementById("GroupedBarChart").getContext("2d");
    const fontSpec = {
      family: "futura-pt, Avenir, Montserrat, sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.5,
      weight: 400,
    };
    var myChart = new Chart(ctx, {
      type: "bar",
      data: {
        labels: [
          "Direct emissions from mobile combustion",
          "Indirect emissions from imported electricity",
          "Energy-related emissions scope 3",
          "Purchased goods and capital goods",
          "Disposal of solid and liquid wastes",
          "Upstream transportation and distribution",
          "Business travels",
          "Employee commuting",
        ],
        datasets: [
          {
            label: "2019 (baseline)",
            data: [67.69, 12.54, 6.57, 717.23, 1.61, 4347.7, 13386.57, 326.25],
            backgroundColor: "#BEBEBE",
            maxBarThickness: 48,
          },
          {
            label: "2020",
            data: [3.4, 35.89, 11.64, 253.9, 0.47, 2850.46, 9349.81, 189.37],
            backgroundColor: "#8F9AA6",
            maxBarThickness: 48,
          },
          {
            label: "2021",
            data: [0.0, 31.58, 13.57, 587.59, 0.41, 1718.02, 9955.49, 175.17],
            backgroundColor: "#5F768F",
            maxBarThickness: 48,
          },
          {
            label: "2022",
            data: [35.02, 35.02, 10.6, 211.67, 1.58, 5216.09, 13999.03, 267.61],
            backgroundColor: "#305177",
            maxBarThickness: 48,
          },
          {
            label: "2023",
            data: [
              27.45, 27.75, 8.45, 225.13, 144.05, 5220.78, 15243.83, 237.11,
            ],
            backgroundColor: "#002D5F",
            maxBarThickness: 48,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              font: fontSpec,
            },
          },
          x: {
            ticks: {
              font: fontSpec,
            },
          },
        },
        plugins: {
          deferred: {
            xOffset: 150, // Defer until 150px of the canvas width are inside the viewport
            yOffset: "50%", // Defer until 50% of the canvas height are inside the viewport
            delay: 500, // Delay of 500 ms after the canvas is considered inside the viewport
          },
          legend: {
            position: "bottom",
            labels: {
              font: fontSpec,
              padding: 20,
            },
          },
          tooltip: {
            mode: "index",
            intersect: false,
            bodyFont: fontSpec,
            titleFont: fontSpec,
          },
        },
      },
    });
    window.addEventListener("resize", function () {
      myChart.resize();
    });
  },

  initStackedBarChart() {
    Chart.register(ChartDeferred);
    Chart.defaults.color = "#000C1A";

    const fontSpec = {
      family: "futura-pt, Avenir, Montserrat, sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: 400,
    };

    const ctx = document.getElementById("StackedBarChart").getContext("2d");
    const myChart = new Chart(ctx, {
      type: "bar",
      data: {
        labels: [
          "2013",
          "2014",
          "2015",
          "2016",
          "2017",
          "2018",
          "2019",
          "2020",
          "2021",
          "2022",
          "2023",
        ],
        datasets: [
          {
            label: "Members",
            backgroundColor: "#1F6416",
          },
          {
            label: "Circuits",
            backgroundColor: "#2D7B23",
          },
          {
            label: "Events",
            data: [0, 2, 2, 6, 11, 12, 11, 14, 19, 25, 35],
            backgroundColor: "#3B922F",
          },
          {
            label: "Teams",
            data: [1, 1, 3, 4, 4, 4, 5, 9, 18, 25, 31],
            backgroundColor: "#48AA3C",
          },
          {
            label: "Suppliers",
            data: [0, 0, 1, 1, 1, 1, 1, 3, 7, 13, 16],
            backgroundColor: "#56C148",
          },
          {
            label: "Promoters",
            data: [0, 0, 1, 1, 1, 1, 1, 2, 3, 3, 5],
            backgroundColor: "#64D855",
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          deferred: {
            xOffset: 150, // Defer until 150px of the canvas width are inside the viewport
            yOffset: "50%", // Defer until 50% of the canvas height are inside the viewport
            delay: 500, // Delay of 500 ms after the canvas is considered inside the viewport
          },
          legend: {
            position: "bottom",
            labels: {
              font: fontSpec,
              padding: 20,
            },
          },
          tooltip: {
            mode: "index",
            intersect: false,
            bodyFont: fontSpec,
            titleFont: fontSpec,
          },
        },
        scales: {
          x: {
            stacked: true,
            ticks: {
              font: fontSpec,
            },
            grid: {
              color: "transparent",
            },
          },
          y: {
            stacked: true,
            ticks: {
              beginAtZero: true,
              font: fontSpec,
            },
            title: {
              display: true,
              text: "Number of accreditations",
              font: fontSpec,
            },
          },
        },
      },
    });
    window.addEventListener("resize", function () {
      myChart.resize();
    });
  },
  initDoughnutChart() {
    Chart.register(ChartDeferred);
    Chart.defaults.color = "#000C1A";

    var ctx = document.getElementById("DoughnutChart").getContext("2d");

    const fontSpec = {
      family: "futura-pt, Avenir, Montserrat, sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: 400,
    };

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      cutout: "50%",
      plugins: {
        deferred: {
          xOffset: 150, // Defer until 150px of the canvas width are inside the viewport
          yOffset: "50%", // Defer until 50% of the canvas height are inside the viewport
          delay: 500, // Delay of 500 ms after the canvas is considered inside the viewport
        },
        legend: {
          position: "bottom",
          display: true,
          labels: {
            font: fontSpec,
            padding: 20,
          },
        },
        tooltip: {
          bodyFont: fontSpec,
          titleFont: fontSpec,
        },
      },
      // layout: {
      //   padding: 96,
      // }
    };

    const data = {
      labels: [
        "FIA Business Travels",
        "FIA Freight Transports",
        "Other Activities",
      ],
      datasets: [
        {
          data: [72.18, 24.72, 3.11],
          backgroundColor: ["#002D5F", "#64D855", "#00B4E1"],
          borderColor: "rgba(0,0,0,0)",
        },
      ],
    };
    const config = {
      type: "doughnut",
      data: data,
      options: options,
    };

    var myChart = new Chart(ctx, config);
    window.addEventListener("resize", function () {
      myChart.resize();
    });
  },

  initNewStackedBarLineChart() {
    var ctx = document.getElementById("StackedBarLineChart").getContext("2d");

    const data = {
      labels: [
        "2019",
        "2020",
        "2021",
        "2022",
        "2023",
        "2024",
        "2025",
        "2026",
        "2027",
        "2028",
        "2029",
        "2030",
      ],
      datasets: [
        {
          label: "Calculated footprint",
          data: [
            18910.69, 6173.01, 13018.59, 19037.43, 14697.45, 13799.89, 12957.14,
            12165.86, 11422.9, 10725.32, 10070.33, 9455.35,
          ],
          backgroundColor: "navy",
          borderColor: "navy",
          borderWidth: 1,
        },
        {
          label:
            "Future footprints - target of reducing emissions by 50% by 2030",
          data: [
            18910, 18115.78, 17321.56, 16527.34, 14697.448, 13799.888,
            12957.141, 12165.861, 11422.902, 10725.316, 10070.331, 9455.345,
          ],
          backgroundColor: "grey",
          borderColor: "grey",
          borderWidth: 1,
        },
        {
          label: "Carbon offset",
          data: [
            0, -6173.01, -13018.59, -19037.43, -14697.45, -13799.89, -12957.14,
            -12165.86, -11422.9, -10725.32, -10070.33, -9455.345,
          ],
          backgroundColor: "lightblue",
          borderColor: "lightblue",
          borderWidth: 1,
        },
        {
          label: "Carbon removals - mix offset and removals",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          backgroundColor: "cyan",
          borderColor: "cyan",
          borderWidth: 1,
        },
        {
          label: "Reduction targets",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          backgroundColor: "lightgreen",
          borderColor: "lightgreen",
          borderWidth: 1,
        },
      ],
    };

    const config = {
      type: "bar",
      data: data,
      options: {
        scales: {
          y: {
            beginAtZero: true,
          },
        },
      },
    };

    new Chart(ctx, config);
  },

  initStackedBarLineChart() {
    Chart.register(ChartDeferred);
    Chart.defaults.color = "#000C1A";
    var ctx = document.getElementById("StackedBarLineChart").getContext("2d");

    const fontSpec = {
      family: "futura-pt, Avenir, Montserrat, sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: 400,
    };

    var myChart = new Chart(ctx, {
      type: "bar",
      data: {
        labels: [
          "2019 (baseline)",
          "2020",
          "2021",
          "2022",
          "2023",
          "2024",
          "2025",
          "2026",
          "2027",
          "2028",
          "2029",
          "2030",
        ],
        datasets: [
          {
            label:
              "Trajectory aligned with 50% reduction by 2030 and 90% reduction by 2040",
            data: [
              18910, 18115.78, 17321.56, 16527.34, 14697.448, 13799.888,
              12957.141, 12165.861, 11422.902, 10725.316, 10070.331, 9455.345,
            ],

            type: "line",
            fill: false,
            backgroundColor: "#64D855",
            borderColor: "#64D855",
            borderWidth: 2,
          },

          {
            label: "Calculated footprint",
            data: [18910.69, 6173.01, 13018.59, 19037.43, 21120.63],
            backgroundColor: "#002D5F", // Dark blue color
            borderColor: "#002D5F",
            borderWidth: 1,
            maxBarThickness: 48,
          },
          {
            label:
              "Footprint estimation per year (target of reducing the emissions by 50% by 2030)",

            data: [
              0, 0, 0, 0, 0, 13799.89, 12957.14, 12165.86, 11422.9, 10725.32,
              10070.33, 9455.35,
            ],
            backgroundColor: "#808080", // Grey color
            borderColor: "#808080",
            borderWidth: 1,
            maxBarThickness: 48,
          },
          {
            label: "Carbon offset",
            data: [0, -6173.01, -13018.59, -19037.43, 0, 0, 0, 0, 0, 0, 0, 0],
            backgroundColor: "#00B4E1", // Blue color
            borderColor: "#00B4E1",
            borderWidth: 1,
            maxBarThickness: 48,
          },
          {
            label:
              "Carbon reductions / carbon removals (for decisions in revised strategy)",
            data: [
              0, 0, 0, 0, -21120.63, -13799.89, -12957.14, -12165.86, -11422.9,
              -10725.32, -10070.33, -9455.35,
            ],
            backgroundColor: "#BEBEBE", // Grey color
            borderColor: "#BEBEBE",
            borderWidth: 1,
            maxBarThickness: 48,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            ticks: {
              font: fontSpec,
            },
            stacked: true,
            grid: {
              color: "transparent",
            },
          },
          y: {
            beginAtZero: true,
            ticks: {
              callback: function (value) {
                return value.toLocaleString(); // Format numbers with commas
              },
              font: fontSpec,
            },
            position: "left",
            title: {
              display: true,
              text: "t CO2e",
              font: fontSpec,
            },
          },
        },
        plugins: {
          deferred: {
            xOffset: 150, // Defer until 150px of the canvas width are inside the viewport
            yOffset: "50%", // Defer until 50% of the canvas height are inside the viewport
            delay: 500, // Delay of 500 ms after the canvas is considered inside the viewport
          },
          legend: {
            position: "bottom",
            display: true,
            labels: {
              font: fontSpec,
              padding: 20,
            },
          },
          tooltip: {
            bodyFont: fontSpec,
            titleFont: fontSpec,
          },
        },
      },
    });
    window.addEventListener("resize", function () {
      myChart.resize();
    });
  },

  initBarLineChart() {
    Chart.register(ChartDeferred);
    Chart.defaults.color = "#000C1A";

    var ctx = document.getElementById("BarLineChart").getContext("2d");

    const fontSpec = {
      family: "futura-pt, Avenir, Montserrat, sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: 400,
    };

    var myChart = new Chart(ctx, {
      type: "bar",
      data: {
        labels: ["2019 (baseline)", "2020", "2021", "2022", "2023"],
        datasets: [
          {
            label: "Average footprint per employee tCO2e",
            data: [85.96, 25.3, 50.85, 72.39, 78.32],
            type: "line",
            fill: false,
            backgroundColor: "#64D855",
            borderColor: "#64D855",
            borderWidth: 2,
            yAxisID: "y1",
          },
          {
            label: "Total emissions tCO2e",
            data: [18910.69, 6173.01, 13018.59, 19037.43, 21120.63],
            backgroundColor: "#002D5F ", // Dark blue color
            borderColor: "#002D5F ",
            borderWidth: 1,
            yAxisID: "y",
            maxBarThickness: 48,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: true,
            position: "left",
            ticks: {
              callback: function (value) {
                return value.toLocaleString(); // Format numbers with commas
              },
              font: fontSpec,
              precision: 0,
              stepSize: 4000,
            },
            title: {
              display: true,
              text: "t CO2e",
              font: fontSpec,
            },
          },
          y1: {
            beginAtZero: true,
            position: "right",
            min: 0,
            max: 100,
            ticks: {
              callback: function (value) {
                return value.toFixed(0); // Show integers
              },
              precision: 0,
              stepSize: 20,
              font: fontSpec,
            },
            title: {
              display: true,
              text: "t CO2e / employee",
              font: {
                ...fontSpec,
              },
            },
            grid: {
              drawOnChartArea: false, // Remove grid lines
            },
          },
          x: {
            ticks: {
              font: fontSpec,
            },
            grid: {
              color: "transparent",
            },
          },
        },
        plugins: {
          deferred: {
            xOffset: 150, // Defer until 150px of the canvas width are inside the viewport
            yOffset: "50%", // Defer until 50% of the canvas height are inside the viewport
            delay: 500, // Delay of 500 ms after the canvas is considered inside the viewport
          },
          legend: {
            position: "bottom",
            display: true,
            labels: {
              font: fontSpec,
              padding: 20,
            },
          },
          tooltip: {
            bodyFont: fontSpec,
          },
        },
      },
    });
    window.addEventListener("resize", function () {
      myChart.resize();
    });
  },

  initBarChart() {
    Chart.register(ChartDeferred);
    Chart.defaults.color = "#000C1A"; // Text color

    const ctx = document.getElementById("BarChart");

    const fontSpec = {
      family: "futura-pt, Avenir, Montserrat, sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.5,
      weight: 400,
    };

    const data = {
      labels: [""],
      datasets: [
        {
          label:
            "Scope 1 and 2: Direct GHG emissions and Indirect emissions linked to energy",
          maxBarThickness: 48,
          minBarLength: 1,
          data: [0.11],
          borderWidth: 0,
          backgroundColor: [
            "#002D5F",
            // '#64D855',
          ],
        },
        {
          label: "Scope 3: Other indirect GHG emissions",
          maxBarThickness: 48,
          minBarLength: 1,
          data: [99.89],
          borderWidth: 0,
          backgroundColor: [
            // '#002D5F',
            "#64D855",
          ],
        },
      ],
    };

    const config = {
      type: "bar",
      data: data,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              stepSize: 20,
              callback: function (value) {
                return (value * 1).toFixed(0) + "%"; // Convert the value to a percentage
              },
              font: fontSpec,
            },
          },
          x: {
            ticks: {
              font: fontSpec,
            },
            grid: {
              color: "transparent",
            },
          },
        },
        plugins: {
          deferred: {
            xOffset: 150, // Defer until 150px of the canvas width are inside the viewport
            yOffset: "50%", // Defer until 50% of the canvas height are inside the viewport
            delay: 500, // Delay of 500 ms after the canvas is considered inside the viewport
          },
          legend: {
            position: "bottom",
            // display: false,
            labels: {
              font: fontSpec,
              padding: 20,
            },
          },
          tooltip: {
            bodyFont: fontSpec,
            titleFont: fontSpec,
          },
        },
      },
    };

    const myChart = new Chart(ctx, config);

    window.addEventListener("resize", function () {
      myChart.resize();
    });
  },

  getDecimalPlaces(value) {
    const valueString = value.toString();
    if (valueString.includes(".")) {
      return valueString.split(".")[1].length || 0;
    }
    return 0;
  },

  initCountUp() {
    const figureElements = document.querySelectorAll(".box-item__figure");
    Array.from(figureElements).forEach((figureEl) => {
      const dataFigure = figureEl.getAttribute("data-figure");

      // Original number
      var originalNumber = parseFloat(dataFigure);

      // Determine the number of decimal places in the original number
      var decimalPlaces = this.getDecimalPlaces(originalNumber);

      new CountUp(figureEl, dataFigure, {
        duration: 0.5,
        enableScrollSpy: true,
        scrollSpyOnce: true,
        decimalPlaces: decimalPlaces,
        useGrouping: true,
      });
    });
  },

  initBoxSlideGalleryMultiBlockSwipers() {
    // Block
    const boxSlideBlocks = document.querySelectorAll(
      ".box-slides-gallery-multi"
    );

    boxSlideBlocks.forEach((el, i = 0) => {
      const swiperClass = "box-slides-gallery-multi" + i;
      el.classList.add(swiperClass);

      try {
        new Swiper("." + swiperClass, {
          modules: [Navigation],
          slideToClickedSlide: false,
          slidesPerView: "1",
          spaceBetween: 24,
          navigation: {
            nextEl:
              "." + swiperClass + " .swiper-button-next.swiper-main-button",
            prevEl:
              "." + swiperClass + " .swiper-button-prev.swiper-main-button",
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
              slidesPerGroup: 2,
            },
            1440: {
              slidesPerView: 4,
              slidesPerGroup: 4,
            },
          },
        });
      } catch (error) {
        console.log(error);
      }
    });
  },

  initBoxSlideGalleryBlockSwipers() {
    // Block
    const boxSlideBlocks = document.querySelectorAll(".box-slides-gallery");

    boxSlideBlocks.forEach((el, i = 0) => {
      const swiperClass = "box-slides-gallery" + i;
      el.classList.add(swiperClass);

      try {
        new Swiper("." + swiperClass, {
          modules: [Navigation],
          slideToClickedSlide: false,
          slidesPerView: "1",
          spaceBetween: 24,
          navigation: {
            nextEl:
              "." + swiperClass + " .swiper-button-next.swiper-main-button",
            prevEl:
              "." + swiperClass + " .swiper-button-prev.swiper-main-button",
          },
          breakpoints: {
            768: {
              slidesPerView: "2",
            },
          },
        });
      } catch (error) {}
    });
  },

  async initScrollIntoView() {
    await wait(1000);

    const formElements = document.querySelectorAll(
      ".scrollToElementFormTarget"
    );
    const buttonTriggers = document.querySelectorAll(
      ".scrollToElementButtonTrigger"
    );

    const navEl = document.getElementById("site-nav");
    const navHeight = navEl ? navEl.clientHeight : 0;

    if (buttonTriggers && formElements) {
      let i = 0;
      Array.from(buttonTriggers).forEach((el) => {
        if (el.classList.contains(`scrollToElementButtonTrigger${i}`)) {
          const targetElem = document.querySelector(
            `.scrollToElementFormTarget${i}`
          );
          const formElementOffset = targetElem ? targetElem.offsetTop : 0;

          el.addEventListener("click", () => {
            window.scrollTo({
              top: formElementOffset - navHeight,
              behavior: "smooth",
            });
          });
        }
        i++;
      });
    }
  },

  recordNavBarHeight() {
    const el = document.querySelector(".nav");
    const height = el ? el.clientHeight : 0;
    setCSSCustomProperty("--nav-height", height + "px");
    return height;
  },

  initMeasurementCheckersHome() {
    const handleWindowLoad = () => {
      this.initScrollIntoView();
    };
    const handleWindowResize = () => {
      this.initScrollIntoView();
    };
    window.addEventListener("load", handleWindowLoad);
    window.addEventListener("resize", handleWindowResize);
  },
};
